import React from 'react';

import { Box, styled } from '@mui/material';

import { Skeleton } from '../../Skeleton';

const styles = () => ({
  width: '70%',
  maxWidth: '200px',
  '.MuiSkeleton-root': {
    borderRadius: '500px',
  },
});

export const SkeletonStatusCell = styled(({ ...props }) => (
  <Box {...props}>
    <Skeleton variant="rectangular" height={25} width="100%" />
  </Box>
))(styles);
